import { Button } from "@/components/ui/button";
import {
  Download,
  Pause,
  Play,
  RefreshCcw,
  Send,
  StopCircle,
} from "lucide-react";

export const RecordingStateActions = ({
  currentRecording,
  recording,
  isPaused,
  handleStopRecording,
  handlePauseResumeRecording,
  handleDownload,
  handleSend,
  handleRecordAgain,
  canUpdateMentorships,
}: {
  currentRecording: any;
  recording: boolean;
  isPaused: boolean;
  handleStopRecording: () => void;
  handlePauseResumeRecording: () => void;
  handleDownload: () => void;
  handleSend: () => void;
  handleRecordAgain: () => void;
  canUpdateMentorships: boolean;
}) => {
  return (
    <div className="absolute bottom-8 left-1/2 flex -translate-x-1/2 transform items-center gap-4">
      {recording && canUpdateMentorships && (
        <>
          <Button onClick={handleStopRecording} size="lg" variant="destructive">
            <StopCircle className="mr-2 h-5 w-5" />
            Stop
          </Button>
          <Button
            onClick={handlePauseResumeRecording}
            size="lg"
            variant="secondary"
          >
            {!isPaused ? (
              <Pause className="mr-2 h-5 w-5" />
            ) : (
              <Play className="mr-2 h-5 w-5" />
            )}
            {!isPaused ? "Pause" : "Resume"}
          </Button>
        </>
      )}
      {currentRecording.blob && (
        <div className="flex gap-2">
          <Button onClick={handleDownload} size="lg" variant="secondary">
            <Download className="mr-2 h-5 w-5" />
            Download
          </Button>
          {canUpdateMentorships && (
            <>
              <Button
                size="lg"
                variant="default"
                onClick={handleSend}
                disabled={!currentRecording.blob}
              >
                <Send className="mr-2 h-5 w-5" />
                Send
              </Button>
              <Button onClick={handleRecordAgain} size="lg" variant="outline">
                <RefreshCcw className="mr-2 h-5 w-5" />
                Record Again
              </Button>
            </>
          )}
        </div>
      )}
    </div>
  );
};
